<svelte:options runes={false} />

<script>
  import { SUPPORTED_INVOICE_CURRENCIES } from '../../api/currencies';

  export let value;
  export let disabled = false;
  export let label = 'Currency';
  export let onChange = null;

  function handleChange(event) {
    value = event.target.value;
    if (onChange) onChange(event);
  }
</script>

<label>
  {label}
  <select {value} {disabled} on:change={handleChange}>
    {#each SUPPORTED_INVOICE_CURRENCIES as currency (currency.code)}
      <option value={currency.code}>{currency.label}</option>
    {/each}
  </select>
</label>
